export default __webpack_public_path__ + "static/media/photo6.c6d2c8c7.jpg";